<template>
    <div>
        <page-header :heading="pageHeader.title"
                     :buttons="pageHeader.buttons" />

        <search-form key="claimsSearch1"
                     :inputs="searchInputsEx"
                     class="mb-5"
                     @clear="handleClearClick"
                     @search="handleSearchClick" />

        <hr />
        <div>
            <b-dropdown size="lg" id="claimActions" text="Actions" class="m-md-2">
                <b-dropdown-item @click="handleExportClick">
                    Export
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item :disabled="!(selectedItems && selectedItems.length > 0)"
                                 @click="handleTaskClick">
                    Mark As
                </b-dropdown-item>
            </b-dropdown>
        </div>
        <hr />

        <transition name="fade">
            <select-task v-if="showFlag && (selectedItems && selectedItems.length > 0)"
                         :tasks="taskOptions"
                         :button_text="`Set (${selectedItems.length} records)`"
                         class="mb-2 border-bottom"
                         @button-click="handleUpdateFlagsClick" />
        </transition>

        <transition name="fade">
            <data-list-csv v-if="showExport"
                           class="mb-2 border-bottom"
                           :dataCols="claimsCols"
                           :dataListItems="claimsList"
                           :selectedItems="selectedItems">
            </data-list-csv>

        </transition>

        <div class="row">
            <div class="col">
                <page-size v-model="pageSize"
                           @input="handlePageSizeChange" />
            </div>
            <div class="col">
                <order-by v-model="selectedOrderBy"
                          :options="orderByOptionsOverride"
                          @goClick="handleOrderByClick" />
            </div>
        </div>

        <data-list-pagination :dataCols="claimsCols"
                              :dataListItems="claimsList"
                              :showCheckbox="true"
                              :tableClass="'table table-striped table-sm'"
                              :totalRecords="totalRecords"
                              :pageNumber="pageNumber"
                              :pageSize="pageSize"
                              @change="handleSelectedItemsChange"
                              @dbl-click="handleItemDblClick"
                              @pagination-input="handlePagenationInput" />

        <!--<data-list :dataCols="claimsCols"
               :dataListItems="claimsList"
               :tableClass="'table table-striped table-sm'"
               :showCheckbox="true"
               @change="handleSelectedItemsChange"
               @dbl-click="handleItemDblClick" />

    <b-pagination align="center"
                  size="md"
                  :total-rows="totalRecords"
                  v-model="pageNumber"
                  :per-page="pageSize"
                  @input="handlePagenationInput" />-->

        <loading :active.sync="isLoading"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
    </div>
</template>

<script>
import claimsSearch from '@/mixins/claimsSearch.js'
import PageHeader from '@/components/PageHeader.vue'
import PageSize from '@/components/PageSize.vue'
import OrderBy from '@/components/OrderBy.vue'
import DataListCSV from '@/components/DataListCSV.vue'
import SelectTask from '@/components/SelectTask.vue'
    import DataList from '@/components/DataList.vue'
    import DataListPagination from "@/components/DataListPagination.vue";
import SearchForm from '@/components/SearchForm.vue'
import { searchInputs } from '@/ui.config/inputs/claimsBucket2SearchInputs'
import { claimsCols } from '@/ui.config/cols/claimsBucket2ClaimsCols'

//import { mapActions } from 'vuex'

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

    let indexOfObject = function (array, prop, value) {
    for (var i = 0; i < array.length; i += 1) {
        if (array[i][prop] === value) {
            return i;
        }
    }
    return -1;
}
export default {
    name:'ClaimsBucket2',
    mixins: [
        claimsSearch,
    ],
    components: {
        PageHeader,
        DataList,
        'data-list-pagination': DataListPagination,
        'data-list-csv': DataListCSV,
        'select-task': SelectTask,
        PageSize,
        OrderBy,
        SearchForm,
        Loading
    },
    data: () => {
        return {
            pageHeader: {
                title: 'Claims (Recent Document Uploads)',
            },
            searchInputs: searchInputs,
            claimsCols: claimsCols,

            insuranceLineTypes: [
                {
                    id: 1,
                    label: 'GADGET'
                },
                {
                    id: 2,
                    label: 'TIGA'
                },
                {
                    id: 5,
                    label: 'POLICE FED'
                }
            ],
        }
    },
    beforeMount() {
        //this.claimsSearch(null, 1)
        this.fetchResellers()
        this.fetchDocumentTypes()
        },
        mounted() {
            this.clearClaimsList()
        },
    computed: {
        searchInputsEx() {
            var { resellers, documentTypes, searchInputs, insuranceLineTypes } = this

            if (documentTypes) {
                searchInputs[3].options = documentTypes
            }

            if (searchInputs && searchInputs.length > 0) {

                if (resellers) {
                    let resellersIndex = indexOfObject(searchInputs, 'id', 'reseller')
                    if (resellersIndex > -1) {
                        searchInputs[resellersIndex].options = resellers
                    }
                }

                if (documentTypes) {
                    let documentTypesIndex = indexOfObject(searchInputs, 'id', 'documentType')
                    if (documentTypesIndex > -1) {
                        searchInputs[documentTypesIndex].options = documentTypes
                    }
                }

                if (insuranceLineTypes) {
                    let insuranceLineIndex = indexOfObject(searchInputs, 'id', 'insuranceLine')
                    if (insuranceLineIndex > -1) {
                        searchInputs[insuranceLineIndex].options = insuranceLineTypes
                    }
                }
            }

            return searchInputs
        },
        taskOptions() {
            return [
                { text: 'Updated EVO with supporting documents', value: '1001' },
                { text: 'Updated EVO with repair documents (invoice)', value: '1002' }
            ]
        },
        orderByOptionsOverride() {
            return [
                {
                    id: 0,
                    key: 'LatestUploadDate',
                    label: 'Upload Date'
                }
            ]
        },
    },
    methods: {
        // Override mixin
        buildSearchValues(payload) {
            if (payload != null) {
                let { reseller, claimReference, relatedReference, documentType, insuranceLine } = payload

                let criteria = {
                    resellerId: reseller ? reseller.id : null,
                    claimReference: claimReference,
                    relatedReference,
                    documentTypeId: documentType ? documentType.id : null,
                    insuranceLineId: insuranceLine ? insuranceLine.id : null
                }

                return criteria
            } else {
                return null
            }
        },
        handleUpdateFlagsClick(evPayload) {
            let selected = evPayload

            let { selectedItems } = this
            let criteria = this.buildSearchCriteria(this.buildSearchValues(this.searchPayload))
            this.selectedItems = []
            this.selected = null
            this.showFlag = false

            this.updateClaimsDocTaskFlags(
                {
                    claimSearchCriteria: criteria,
                    claims: selectedItems.map(i => {
                        return {
                            claimId: i.claimId,
                            rowVersion: i.claimRowVersion
                        }
                    }),
                    taskFlags: selected
                }
            )
        },
        //  Override mixin
        claimsSearch(searchValues, pageNumber) {            
            this.clearClaimsList()

            let criteria = this.buildSearchCriteria(searchValues, pageNumber)
            this.fetchClaimsLatestDocUploadListPagenated(criteria)
        }
    }
}
</script>

<style>

</style>
